import React from "react";
import { useDispatch } from "react-redux";
import { getAssetClass } from "pages/redesign/publications/api/searchRequest/urlHelpers";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ErrorBoundary from "lib/ErrorBoundary";
import { setPreference } from "pages/preferences/preferencesActions";
import { Row, Col, Container } from "react-bootstrap";
import { PAGINATION_POS, VIEW } from "redux/slices/api/initialisePreferences";
import { NumberOfSearchResults } from "pages/latestResearch/publications/toolbar/parts/NumberOfSearchResults";
import { _t } from "app/i18n/i18n";
import { ListView } from "pages/latestResearch/publications/listView/ListView";
import { TileView } from "pages/latestResearch/publications/tileView/TileView";
import { FeaturedTileView } from "pages/latestResearch/publications/featured/TileView";
import useIsMobile from "lib/hooks/useIsMobile";
import { PaginationControl } from "pages/latestResearch/publications/pagination/PaginationControl";
import { LoadingSpinner } from "lib/Spinner";
import { useGetFirstPreference, useHasPreference } from "pages/preferences/api/useGetPreferences";
import { features } from "app/features";
import { ServiceNotification } from "pages/latestResearch/notification/ServiceNotification";
import { AdvertBanner } from "pages/ads/adverts/AdvertBanner";
import { CoverImageDataProvider } from "pages/latestResearch/publications/featured/CoverImageDataProvider";
import { Toolbar } from "./toolbar/Toolbar";
import { PillsBar } from "./toolbar/PillsBarRedesign";
import { SidePanel } from "./sidePanel/collaspingPanel/SidePanel";
import "./titlebar.css";

export function ViewLayoutRedesign({ searchResults = [] }) {
  const [publications, , , aggregations, totalHits] = searchResults;
  const viewMode = useGetFirstPreference(VIEW);
  const isPaginationTop = useHasPreference(PAGINATION_POS, "Top & Bottom");
  const dispatch = useDispatch();
  const setViewMode = (mode) => dispatch(setPreference({ key: VIEW, value: mode }));
  const location = useLocation();
  const assetClass = getAssetClass(location);
  const records = totalHits || 0;
  const isMobile = useIsMobile();
  const isLoading = searchResults?.[1];
  return (
    <ErrorBoundary>
      <Container fluid className="redesign">
        <Row className="flex-nowrap w-100">
          {!isMobile && <SidePanel aggregations={aggregations} />}
          <LoadingSpinner className={isLoading ? "d-flex mx-auto pt-5 screen-height" : "d-none"} />
          <Col className={`px-2 overflow-x-hidden ${isLoading ? "d-none" : ""}`}>
            {features.serviceNotifications && features.isRedesignBulletin && <ServiceNotification />}
            {isPaginationTop && <PaginationControl records={records} />}
            <PillsBar />
            <div className="maxw-1100">
              <AdvertBanner />
            </div>
            {features.isfeaturedResearchVisible && assetClass === "Home" && (
              <CoverImageDataProvider>
                <FeaturedTileView searchResults={searchResults} />
              </CoverImageDataProvider>
            )}
            <LatestResearchTitle />
            <Toolbar viewMode={viewMode} setViewMode={setViewMode} searchResults={searchResults} />
            {viewMode === "List" ? <ListView publications={publications} /> : <TileView publications={publications} />}
            <PaginationControl records={records} />
            <NumberOfSearchResults number={totalHits} className="text-center" />
          </Col>
        </Row>
      </Container>
    </ErrorBoundary>
  );
}

function LatestResearchTitle({ className = "" }) {
  return (
    <section className="d-flex flex-row align-items-center mb-2 overflow-x-auto title-bar">
      <span className="px-2 title-text">{_t("LATEST RESEARCH")}</span>
    </section>
  );
}

export function NoPublicationsFound() {
  return <center className="m-5 text-muted">{_t("No Publications Found")}</center>;
}
